export enum ReviewItemTitle {
  Advantage = 'Достоинства:',
  Disadvantage ='Недостатки:',
  Review = 'Комментарий:',
}
